(function() {
    angular
        .module('emarket.main.profile')
        .controller('ChatController', ['$log', '$q', '$scope', '$rootScope', '$state', '$stateParams', '$mdMedia', 'Chat', 'Announcer', 'Profile', 'Auth', function($log,
            $q,
            $scope,
            $rootScope,
            $state,
            $stateParams,
            $mdMedia,
            Chat,
            Announcer,
            Profile,
            Auth) {
            var user = Auth.getUser();
            var isMobile = $mdMedia('xs') || $mdMedia('sm');
            var announcer = Announcer.create($scope);
            var vm = this;
            vm.showList = true;
            vm.showDetail = true;
            vm.user = user;
            var sortedChat = function(a, b) {
                return new Date(b.lastMessage.createdAt) - new Date(a.lastMessage.createdAt);
            };
            announcer.on(Announcer.types.CHAT_MESSAGE_RECEIVER, function(e, msg) {
                if ($state.current.name === 'main.profile.chat') {
                    var defer = $q.defer();
                    var chatFound = vm.chats.some(function(chat) {
                        if (chat._id === msg.chat) {
                            chat.$refresh().$then(function() {
                                defer.resolve();
                            });
                            return true;
                        }
                    });
                    if (!chatFound) {
                        Chat.$find(msg.chat).$then(function(chat) {
                            vm.chats.push(chat);
                            defer.resolve();
                        });
                    }
                    defer.promise.then(function() {
                        vm.chats = vm.chats.sort(sortedChat);
                    });
                }
            });

            announcer.on(Chat.events.ON_SELECT_CHAT, function(e, chat) {
                vm.currenChat = chat;
                vm.chats.some(function(c) {
                    if (c._id === chat._id) {
                        c.unread[user._id] = 0;
                        return true;
                    }
                });
            });
            var handleView = function(state) {
                if (state === 'main.profile.chat' && isMobile) {
                    vm.showList = true;
                    vm.showDetail = false;
                }
                if (state === 'main.profile.chat.detail' && isMobile) {
                    vm.showList = false;
                    vm.showDetail = true;
                }
            };
            handleView($state.current.name);
            vm.transitionOption = {
                location: 'replace'
            };

            if (isMobile) {
                vm.transitionOption.location = true;
            }
            Profile.getConversations().then(function(chats) {
                chats.forEach(function(chat) {
                    chat.participants = chat.participants.filter(function(participant) {
                        return participant._id !== user._id;
                    });
                });
                vm.chats = chats.sort(sortedChat);
            });
            var ev = $rootScope.$on('$stateChangeSuccess', function($event, toState) {
                if (isMobile) {
                    vm.transitionOption.location = true;
                } else {
                    vm.transitionOption.location = 'replace';
                }
                handleView(toState.name);
                if ($stateParams.id) {
                    vm.currenChat = $stateParams.id;
                }
            });
            $scope.$on('$destroy', function() {
                ev();
            });
        }]);
}());
